import React from 'react'
import { ChevronDown, MessageCircle } from 'lucide-react';
import { Button } from "@/components/ui/button"; // Assuming Shadcn UI

interface IChatBotToggleButton {
  isOpen: boolean,
  setIsOpen: (val: boolean) => void
}

function ChatBotToggleButton({ isOpen, setIsOpen }: IChatBotToggleButton) {
  return (
    <Button
      onClick={() => setIsOpen(!isOpen)}
      size="lg"
      className="rounded-full h-14 w-14 shadow-lg p-0 
        flex items-center justify-center 
        transition-transform active:scale-95
        bg-indigo-600"
    >
      {isOpen ? (
        <ChevronDown className="h-6 w-6 animate-in fade-in zoom-in duration-300" />
      ) : (
          <MessageCircle className="h-6 w-6 animate-in fade-in zoom-in duration-300" />
      )}
    </Button>
  )
}

export default ChatBotToggleButton